
const debug = false
// const debug = "projectConvert_checkPageAndConfirm"

export default function projectConvert_checkDocumentAndConfirm(projectIds : ID[]) {
    return new Promise((resolve, reject) => {

        let documentName = ""

        const showWarning = _.some(projectIds, projectId=>{
            const project = gd.session.projects.get(projectId)

            debug && console.log(debug, 'process some', projectId, project)

            if (project?.isPage) documentName = "page"
            if (project?.isWhiteboard) documentName = "whiteboard"

            return project?.isPage || project?.isWhiteboard
        })

        debug && console.log(debug, 'process', showWarning, projectIds)

        if (!showWarning) {
            resolve(true)
            return
        }

        gd.modals.confirm.genericText(
            `Convert ${documentName}`,`Are you sure you want to convert ${documentName.charAt(0).toUpperCase() + documentName.slice(1)}? This action cannot be reverted.`,
            () => {
            gd.modal.hide()
            resolve(true)
        }, {
            yesBtnLabel : 'Yes, proceed',
            onNoCallback: reject
        })
    })
}
